import { render, staticRenderFns } from "./rev_ca.vue?vue&type=template&id=fdc6c3cc"
import script from "./rev_ca.vue?vue&type=script&lang=js"
export * from "./rev_ca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports